module.exports = __webpack_public_path__ + "img/bathroom-interior-1457847.5b62e195.jpg";